import * as actionTypes from "./actionTypes";
import * as types from "./types";


// Extractor actions
export const fetchPatternsReq = (params: types.IPatternParams): types.FetchPatternsReq => ({
    type: actionTypes.FETCH_PATTERNS_REQUEST,
    params,
});

export const fetchPatternsSuccess = (  
    payload: types.FetchPatternsSuccessPayload
): types.FetchPatternsSuccess => ({
    type: actionTypes.FETCH_PATTERNS_SUCCESS,    
    payload,
});

export const fetchPatternsFailure = (
    payload: types.FetchPatternsFailurePayload
): types.FetchPatternsFailure => ({
    type: actionTypes.FETCH_PATTERNS_FAIL,
    payload,
});


//DB Extractor 
export const postDBExtRequest = (payload: types.IDBExtParams): types.PostDBExtRequest => ({
    type: actionTypes.POST_DBEXT_REQUEST,
    payload
});

export const postDBExtReset = (
    ): types.PostDBExtReset => ({
        type: actionTypes.POST_DBEXT_RESET,
    });

export const postDBExtSuccess = (payload: types.IPostDBExtSuccessPayload): types.PostDBExtSuccess => ({
    type: actionTypes.POST_DBEXT_SUCCESS,
    payload
});

export const postDBExtFailure = (payload: types.IPostDBExtFailurePayload): types.PostDBExtFailure => ({
    type: actionTypes.POST_DBEXT_FAILURE,
    payload
});
    

//custom Extractor 
export const postCustomExtRequest = (payload: types.ICustomExtParams): types.PostCustomExtRequest => ({
    type: actionTypes.POST_CUSTOMEXT_REQUEST,
    payload
});

export const postCustomExtSuccess = (payload: types.IPostCustomExtSuccessPayload): types.PostCustomExtSuccess => ({
    type: actionTypes.POST_CUSTOMEXT_SUCCESS,
    payload
});

export const postCustomExtFailure = (payload: types.IPostCustomExtFailurePayload): types.PostCustomExtFailure => ({
    type: actionTypes.POST_CUSTOMEXT_FAILURE,
    payload
});

export const postCustomExtReset = (
    ): types.PostCustomExtReset => ({
        type: actionTypes.POST_CUSTOMEXT_RESET,
    });


// Extractor List actions

export const fetchExtractorListReq = (params: types.IExtractorListParams): types.FetchExtractorListReq => ({
    type: actionTypes.FETCH_EXTRACTOR_LIST_REQUEST,
    params,
});

export const fetchExtractorListSuccess = (
    payload: types.FetchExtractorListSuccessPayload
): types.FetchExtractorListSuccess => ({
    type: actionTypes.FETCH_EXTRACTOR_LIST_SUCCESS,
    payload,
});

export const fetchExtractorListFailure = (
    payload: types.FetchExtractorListFailurePayload
): types.FetchExtractorListFailure => ({
    type: actionTypes.FETCH_EXTRACTOR_LIST_FAILURE,
    payload,
});


// Fetch extractor details

export const fetchExtractorDetailReq = (params: string): types.FetchExtractorDetailReq => ({
    type: actionTypes.FETCH_EXTRACTOR_DETAIL_REQUEST,
    params,
});

export const fetchExtractorDetailSuccess = (  
    payload: types.FetchExtractorDetailSuccessPayload
): types.FetchExtractorDetailSuccess => ({
    type: actionTypes.FETCH_EXTRACTOR_DETAIL_SUCCESS,    
    payload,
});

export const fetchExtractorDetailFailure = (
    payload: types.FetchExtractorDetailFailurePayload
): types.FetchExtractorDetailFailure => ({
    type: actionTypes.FETCH_EXTRACTOR_DETAIL_FAILURE,
    payload,
});

// DELETE Extractor

export const deleteExtractorReq = (
    payload: types.IDeleteParams
): types.DeleteExtractorRequest => ({
    type: actionTypes.DELETE_EXTRACTOR_REQUEST,
    payload,
});

export const deleteExtractorSuccess = (
    payload: types.IDeleteExtractorSuccessPayload
): types.DeleteExtractorSuccess => ({
    type: actionTypes.DELETE_EXTRACTOR_SUCCESS,
    payload,
});

export const deleteExtractorFailure = (
    payload: types.IDeleteExtractorFailurePayload
): types.DeleteExtractorFailure => ({
    type: actionTypes.DELETE_EXTRACTOR_FAILURE,
    payload,
});

// PUT extractor

export const putExtractorRequest = (
    batchCode: string,
    payload: types.IExtractorPutReq
): types.PutExtractorRequest => ({
    type: actionTypes.PUT_EXTRACTOR_REQUEST,
    batchCode,
    payload
});

export const putExtractorSuccess = (
    payload: types.IPutExtractorSuccessPayload
): types.PutExtractorSuccess => ({
    type: actionTypes.PUT_EXTRACTOR_SUCCESS,
    payload,
});

export const putExtractorSkip = (): types.PutExtractorSkip => ({
    type: actionTypes.PUT_EXTRACTOR_SKIP
});

export const putExtractorReset = (
    ): types.PutExtractorReset => ({
        type: actionTypes.PUT_EXTRACTOR_RESET,
    });

export const putExtractorFailure = (
    payload: types.IPutExtractorFailurePayload
): types.PutExtractorFailure => ({
    type: actionTypes.PUT_EXTRACTOR_FAILURE,
    payload,
});

// Fetch extractor status
export const fetchExtractorStatusReq = (params: string): types.FetchExtractorStatusReq => ({
    type: actionTypes.FETCH_EXTRACTOR_STATUS_REQUEST,
    params,
});

export const fetchExtractorStatusSuccess = (  
    payload: types.FetchExtractorStatusSuccessPayload
): types.FetchExtractorStatusSuccess => ({
    type: actionTypes.FETCH_EXTRACTOR_STATUS_SUCCESS,    
    payload,
});

export const fetchExtractorStatusFailure = (
    payload: types.FetchExtractorStatusFailurePayload
): types.FetchExtractorStatusFailure => ({
    type: actionTypes.FETCH_EXTRACTOR_STATUS_FAILURE,
    payload,
});

export const fetchExtractorStatusReset = (
): types.FetchExtractorStatusReset => ({
    type: actionTypes.FETCH_EXTRACTOR_STATUS_RESET,
});

//Edit Extractor Schema
export const postSchemaExtRequest = (
    batchCode: string,
    payload: types.ISchemaExtReq
): types.PostSchemaExtRequest => ({
    type: actionTypes.POST_EXTRACTORSCHEMA_REQUEST,
    batchCode,
    payload
});

export const postSchemaExtSuccess = (
    payload: types.IPostSchemaExtSuccessPayload
): types.PostSchemaExtSuccess => ({
    type: actionTypes.POST_EXTRACTORSCHEMA_SUCCESS,
    payload,
});

export const postSchemaExtFailure = (
    payload: types.IPostSchemaExtFailurePayload
): types.PostSchemaExtFailure => ({
    type: actionTypes.POST_EXTRACTORSCHEMA_FAILURE,
    payload,
});

//Post Retry Schema update
export const postRetrySchemaUpdateRequest = (
    batchCode: string,
    forceValue: boolean
): types.PostRetrySchemaUpdateRequest => ({
    type: actionTypes.POST_RETRYSCHEMAUPDATE_REQUEST,
    batchCode,
    forceValue
});

export const postRetrySchemaUpdateSuccess = (
    payload: types.IPostRetrySchemaUpdateSuccessPayload
): types.PostRetrySchemaUpdateSuccess => ({
    type: actionTypes.POST_RETRYSCHEMAUPDATE_SUCCESS,
    payload,
});

export const postRetrySchemaUpdateFailure = (
    payload: types.IPostRetrySchemaUpdateFailurePayload
): types.PostRetrySchemaUpdateFailure => ({
    type: actionTypes.POST_RETRYSCHEMAUPDATE_FAILURE,
    payload,
});